var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isStudent)?_c('student-account',{attrs:{"params":_vm.params}}):(_vm.isCustomer)?_c('customer-account',{attrs:{"params":_vm.params}}):(_vm.isEmployee)?_c('employee-account',{attrs:{"params":_vm.params}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e451351","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/taskflex/users/pages/Account.vue
// module id = zxUa
// module chunks = 1